import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };
  const navLinks = [{
    label: 'Deal Flow',
    id: 'deals'
  }, {
    label: 'Spotlight Locations',
    id: 'spotlight'
  }, {
    label: 'How It Works',
    id: 'how-it-works'
  }, {
    label: 'About',
    id: 'about'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy shadow-lg' : 'bg-navy/95'}`} data-id="element-285" data-mp="1l1koa9ko7zic">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-286" data-mp="emrg7yptuoe6">
        <div className="flex justify-between items-center h-20" data-id="element-287" data-mp="jmnm63i34pwd">
          <button onClick={() => scrollToSection('hero')} className="text-white font-serif text-xl sm:text-2xl font-semibold hover:text-gold transition-colors" data-id="element-288" data-mp="jn6vivto65ys">
            CaboDealFlow.com
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-289" data-mp="3s38ncy4h6eox">
            {navLinks.map(link => <button key={link.id} onClick={() => scrollToSection(link.id)} className="text-white/90 hover:text-gold transition-colors text-sm font-medium" data-id="element-290" data-mp="ve1qz6s0gq0">
                {link.label}
              </button>)}
            <button onClick={() => scrollToSection('deal-report')} className="bg-gold hover:bg-gold-light text-navy px-6 py-2.5 rounded font-semibold transition-colors text-sm" data-id="element-291" data-mp="39axqbkwi5ayq">
              Access Deal Report
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden text-white p-2" data-id="element-292" data-mp="3b0b6xxpjr1bq">
            {isMobileMenuOpen ? <XIcon size={24} data-id="element-293" data-mp="2idgr5e3ocq4l" /> : <MenuIcon size={24} data-id="element-294" data-mp="2icxi6mw05c2p" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && <div className="md:hidden pb-6 space-y-4" data-id="element-295" data-mp="2dfoyghv7gzzc">
            {navLinks.map(link => <button key={link.id} onClick={() => scrollToSection(link.id)} className="block w-full text-left text-white/90 hover:text-gold transition-colors py-2" data-id="element-296" data-mp="2s8ii8fhig29t">
                {link.label}
              </button>)}
            <button onClick={() => scrollToSection('deal-report')} className="w-full bg-gold hover:bg-gold-light text-navy px-6 py-2.5 rounded font-semibold transition-colors" data-id="element-297" data-mp="2ndod772cej4">
              Access Deal Report
            </button>
          </div>}
      </div>
    </nav>;
}